import { memo } from 'react';

import './customer-service-footer.scss';
import EmailIcon from './email-icon.svg';
import WhatsappIcon from './whatsapp-icon.svg';

const mobileShopConfig = window.GLOBAL_CONFIG.mobileShop || {};

export interface CustomerServiceFooterProps {
  id: string;
}

export const CustomerServiceFooter = memo(({ id }: CustomerServiceFooterProps) => {
  return (
    <div styleName="container">
      <div styleName="title" id={id}>
        聯繫與支持
      </div>
      <div styleName="info-grid">
        <div styleName="label">客服時間:</div>
        <div styleName="value">周一至周五 8:30~17:30</div>
        <div styleName="label">購買咨詢:</div>
        <div styleName="contact-list">
          <a href={mobileShopConfig.whatsappLink} target="_blank" rel="noopener noreferrer" styleName="contact-item">
            <WhatsappIcon styleName="icon" />
            <span>WhatsApp: {mobileShopConfig.whatsapp}</span>
          </a>
          <a href={`mailto:${mobileShopConfig.email}`} styleName="contact-item">
            <EmailIcon styleName="icon" />
            <span>Email: {mobileShopConfig.email}</span>
          </a>
        </div>
      </div>

      <div styleName="footer-links">
        <a href={mobileShopConfig.privacyLink} target="_blank" rel="noopener noreferrer">
          私隐声明
        </a>
        <a href={mobileShopConfig.serviceAgreementLink} target="_blank" rel="noopener noreferrer">
          服务订购协议
        </a>
        <a href={mobileShopConfig.disclaimerLink} target="_blank" rel="noopener noreferrer">
          免责声明
        </a>
        <span styleName="copyright">| {mobileShopConfig.copyright}</span>
      </div>

      <div styleName="disclaimer">
        <span>❗本軟件提供的數據和分析僅供參考，不構成投資建議。投資有風險，入市需謹慎。</span>
      </div>
    </div>
  );
});
